import React from 'react';

import {SmallLoader} from '../small-loader';
import {cls} from '../../utils';

import css from './loader.module.css';

type Props = {
	text?: string;
	withoutLoadingWrapper?: boolean;
};

export const Loader: React.FC<Props> = ({text, withoutLoadingWrapper}) => {
	return (
		<div className={cls(!withoutLoadingWrapper && css.loadingWrapper)}>
			<div className={css.loadingContainer}>
				<div className={css.loading}>
					<SmallLoader />
					<span className={css.loadingText}>{text}</span>
				</div>
			</div>
		</div>
	);
};
